import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { dataAccessProviders } from './shared/data-access/data-access.providers';
import { apiAuthInterceptor } from './shared/data-access/api/api-auth.interceptor';
import { apiErrorInterceptor } from './shared/data-access/api/api-error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([apiAuthInterceptor, apiErrorInterceptor])),
    provideRouter(routes),
    ...dataAccessProviders,
  ],
};
